













































import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import STextarea from '@/common/components/STextarea.vue';

export default defineComponent({
  name: 'UCIrvineChem1LDELN2OIDataAnalysis1',
  components: {STextarea, StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        dataAnalysis2Calculations: null,
      },
      attachments: [] as File[],
      questions: [
        {
          text: 'Any written calculations, data values, and explanations may be included below.',
          inputName: 'dataAnalysis2Calculations',
        },
      ],
    };
  },
});
